export function priceFormat(value: number) {
  if (value >= 10000) {
    const yen = Math.floor(value / 10000).toLocaleString()
    return yen + "万"
  } else {
    return value.toLocaleString()
  }
}
